import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './componentes/home/home.component';
import { CursosDisponiblesComponent } from './componentes/cursos-disponibles/cursos-disponibles.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { NuevoCursoComponent } from './componentes/nuevo-curso/nuevo-curso.component';
import { CursoComponent } from './componentes/curso/curso.component';

import { ToolbarComponent } from './shared/componentes/toolbar/toolbar.component';
import { AboutComponent } from './componentes/about/about.component';


//firebase
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule, BUCKET } from "@angular/fire/storage";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { environment } from 'src/environments/environment';
import { PrecioPipe } from './pipes/precio.pipe';
import { AdminComponent } from './componentes/admin/admin.component';
import { LoginComponent } from './componentes/auth/login/login.component';
import { ReactiveFormsModule } from "@angular/forms";
import { ContainerAppComponent } from './componentes/container-app/container-app.component';
import { ProfileComponent } from './componentes/profile/profile.component';
import { TableComponent } from './shared/componentes/table/table.component';
import { ModalComponent } from './shared/componentes/modal/modal.component';
import { EditarCursoComponent } from './componentes/editar-curso/editar-curso.component';
import { DetailsCursoComponent } from './componentes/details-curso/details-curso.component';
import { RegistroComponent } from './componentes/auth/registro/registro.component';
import { Error404Component } from './componentes/error404/error404.component';
import { FormsModule } from '@angular/forms';
import { ModalVideoComponent } from './shared/componentes/modal-video/modal-video.component';
import { ContenidoPipe } from './pipes/contenido.pipe';

import { MatVideoModule } from 'mat-video';
import { ReproducirCursoComponent } from './componentes/reproducir-curso/reproducir-curso.component';
import { GratisPipe } from './pipes/gratis.pipe';
import { WoyaComponent } from './componentes/woya/woya.component';
import { AuditoriasComponent } from './componentes/auditorias/auditorias.component';

import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { ChartsModule } from 'ng2-charts';
import { FooterComponent } from './shared/componentes/footer/footer.component';
import { FaqComponent } from './componentes/faq/faq.component';
import { MiscursosComponent } from './componentes/miscursos/miscursos.component';
import { HtmlPipe } from './pipes/html.pipe';
import { HabilitarComponent } from './componentes/habilitar/habilitar.component';

import { RecaptchaModule } from "ng-recaptcha";
import { QuiensoyComponent } from './componentes/quiensoy/quiensoy.component';
import { CarruselComponent } from './componentes/carrusel/carrusel.component';
import { NoticiasComponent } from './componentes/noticias/noticias.component';
import { DetailsNoticiaComponent } from './componentes/details-noticia/details-noticia.component';
import { NuevaImagenComponent } from './componentes/nueva-imagen/nueva-imagen.component';
import { NuevoDibujoComponent } from './componentes/nuevo-dibujo/nuevo-dibujo.component';
import { ImagenComponent } from './componentes/imagen/imagen.component';
import { DibujoComponent } from './componentes/dibujo/dibujo.component';
import { LibroComponent } from './componentes/libro/libro.component';
import { NuevoLibroComponent } from './componentes/nuevo-libro/nuevo-libro.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CursosDisponiblesComponent,
    NuevoCursoComponent,
    CursoComponent,
    ToolbarComponent,
    AboutComponent,
    PrecioPipe,
    AdminComponent,
    LoginComponent,
    ContainerAppComponent,
    ProfileComponent,
    TableComponent,
    ModalComponent,
    EditarCursoComponent,
    DetailsCursoComponent,
    RegistroComponent,
    Error404Component,
    ModalVideoComponent,
    ContenidoPipe,
    ReproducirCursoComponent,
    GratisPipe,
    WoyaComponent,
    AuditoriasComponent,
    FooterComponent,
    FaqComponent,
    MiscursosComponent,
    HtmlPipe,
    HabilitarComponent,
    QuiensoyComponent,
    CarruselComponent,
    NoticiasComponent,
    DetailsNoticiaComponent,
    NuevaImagenComponent,
    NuevoDibujoComponent,
    ImagenComponent,
    DibujoComponent,
    LibroComponent,
    NuevoLibroComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    MaterialModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    ReactiveFormsModule,
    FormsModule,
    MatVideoModule,
    MDBBootstrapModule.forRoot(),
    ChartsModule,
    RecaptchaModule,
  ],
  providers: [
    {provide: BUCKET, useValue:"gs://astronomio.appspot.com"}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
